"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var appender_base_1 = require("./appender.base");
var enums_1 = require("../enums");
/**
 * Don't write logs anywhere (: Can be useful for debugging or temporarily switched on in case of exceptional situations
 */
var EmptyAppender = /** @class */ (function (_super) {
    __extends(EmptyAppender, _super);
    function EmptyAppender() {
        var _this = _super.call(this) || this;
        _this.type = enums_1.AppenderType.Empty;
        return _this;
    }
    EmptyAppender.prototype.getAppenderName = function () { return 'EmptyAppender'; };
    EmptyAppender.prototype.action = function (message) { };
    return EmptyAppender;
}(appender_base_1.Appender));
exports.EmptyAppender = EmptyAppender;
//# sourceMappingURL=appender.empty.js.map